export default __webpack_public_path__ + "svTrans.1123eca6129cffd65321d5ed9f3e0f29.png";